
const ErrorLogger = async (errordetails:any) => {
    await fetch("/logerror", {
        method: 'POST',
        body: JSON.stringify(errordetails),
        headers:
        {
            'Content-Type': 'application/json',
        },
    })
}

export default ErrorLogger;